import { RouteProps } from "react-router";
import { Route } from "react-router-dom";

export const PublicRoute = (props: RouteProps) => <Route {...props} />;
